module.exports = __webpack_public_path__ + "static/media/loader.1cb8c795.gif";